<div class="content has-text-left">
    <div class="is-flex-desktop is-aligned-top">
        @if (plan.data.locked === '1') {
            <div class="field plan-locked">
                <div class="checkbox">
                    <input
                        id="locked-{{ plan.id }}"
                        type="checkbox"
                        name="locked-{{ plan.id }}"
                        (change)="lockedToggle()"
                        [checked]="isLocked"
                    />
                    <label class="checkbox-label" for="locked-{{ plan.id }}">Forfait bloqué</label>
                </div>
            </div>
        }
        @if (plan.data.locked === '2') {
            <p class="text plan-locked">- Forfait bloqué -</p>
        }
    </div>
    <p class="is-3 text is-marginless">
        <trg-price
            [inheritFontSize]="true"
            [hasPeriod]="true"
            [isInlined]="true"
            [price]="plan.prices.final"
        ></trg-price>
        @if (plan.prices.duration) {
            <span>
                pendant {{ plan.prices.duration }} mois puis
                <trg-price
                    [inheritFontSize]="true"
                    [hasPeriod]="true"
                    [isInlined]="true"
                    [price]="plan.prices.forever"
                ></trg-price>
            </span>
        }
        @if (plan.data.obligation) {
            <span>- {{ plan.data.obligation | obligationLabel }}</span>
        }
    </p>
    <p class="title is-level-5 mt-3">{{ title }}</p>
    <div class="rows">
        @if (plan?.data?.from_abroad) {
            <div class="row">
                <p class="icon-and-text is-alternate text is-1">
                    <span class="icon is-medium is-secondary">
                        <i class="tri-at-globe"></i>
                    </span>
                    <span>
                        <span>{{ plan.data.from_abroad }}</span>
                        &nbsp;
                        <span
                            class="text link is-level-1 is-marginless is-paddingless"
                            (click)="toggleEuropeAbroadList(true)"
                        >
                            Voir les destinations en Europe
                        </span>
                    </span>
                </p>
                @if (showEuropeAbroadList) {
                    <div
                        class="columns is-multiline is-marginless has-background-grey-fade is-gapless box box-small is-shadowless"
                    >
                        <div class="column is-full has-text-right is-absolute">
                            <span class="icon mr-2" (click)="toggleEuropeAbroadList(false)">
                                <i class="tri-times" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="column">
                            <checkout-cms-block [blockId]="europeCmsBlockId" [battlefront]="false"></checkout-cms-block>
                        </div>
                    </div>
                }
            </div>
        }
        @if (plan?.data?.double_sim) {
            <div class="row">
                <p class="icon-and-text is-alternate text is-1">
                    <span class="icon is-medium is-secondary">
                        <i class="tri-sim-cards"></i>
                    </span>
                    @if (!isDarwin) {
                        <span>
                            Une 2ème carte SIM Internet pour utiliser votre forfait sur un second appareil (tablette,
                            montre...)
                        </span>
                    }
                    @if (isDarwin) {
                        <span>
                            Tous les 6 mois, un nouveau palier, avec appels illimités et plus de gigas (10Go puis 20Go)
                            en France métropolitaine
                        </span>
                    }
                </p>
            </div>
        }
        @if (plan?.data?.sms_mms) {
            <div class="row mb-1">
                <p class="icon-and-text is-alternate text is-1">
                    <span class="icon is-medium is-secondary">
                        <i class="tri-phone-waiting-call"></i>
                    </span>
                    <span>
                        <span [innerHTML]="plan.data.sms_mms"></span>
                        &nbsp;
                        <span
                            class="text link is-level-1 is-marginless is-paddingless"
                            (click)="toggleEuropeSmsMmsList(true)"
                        >
                            Voir les destinations en Europe
                        </span>
                    </span>
                </p>
                @if (showEuropeSmsMmsList) {
                    <div
                        class="columns is-multiline is-marginless has-background-grey-fade is-gapless box box-small is-shadowless"
                    >
                        <div class="column is-full has-text-right is-absolute">
                            <span class="icon mr-2" (click)="toggleEuropeSmsMmsList(false)">
                                <i class="tri-times" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="column">
                            <checkout-cms-block [blockId]="europeCmsBlockId" [battlefront]="false"></checkout-cms-block>
                        </div>
                    </div>
                }
            </div>
        }
        @if (plan.data.international_call) {
            <div class="row">
                <p class="icon-and-text is-alternate text is-1">
                    <span class="icon is-medium is-secondary">
                        <i class="tri-phone-outgoing-call"></i>
                    </span>
                    <span>
                        <span
                            (textWithLink)="toggleInternationalCall(true)"
                            [innerHTML]="plan.data.international_call | trustHtml"
                        ></span>
                        &nbsp;
                        <span
                            class="text link is-level-1 is-marginless is-paddingless"
                            (click)="toggleInternationalCall(true)"
                        >
                            Voir les destinations
                        </span>
                    </span>
                </p>
                @if (showInternationalCallsList) {
                    <div
                        class="columns is-multiline is-marginless has-background-grey-fade is-gapless box box-small is-shadowless"
                    >
                        <div class="column is-full has-text-right is-absolute">
                            <span class="icon mr-2" (click)="toggleInternationalCall(false)">
                                <i class="tri-times" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="column">
                            <checkout-cms-block
                                [blockId]="internationalCallsCmsBlockId"
                                [battlefront]="false"
                            ></checkout-cms-block>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
    @if (planDetails) {
        <span [innerHTML]="planDetails.text_popin"></span>
    }
    @if (!isOwned) {
        <ng-template #customModalFooter>
            <button class="button is-marginless is-primary mt-1" (click)="add()">Choisir ce forfait</button>
        </ng-template>
    }
</div>
